// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FixList--next-sr-only--DqdRRkU","fixList":"FixList--fixList--2IW2CWh","buttons":"FixList--buttons--2pwby9E"};